import React from "react";
import { Page, Spinner, css, spacing } from "../library";
import AgentCard from "./AgentCard";

const grid = css({
  display: "grid",
  // Colunas de largura fixa (não `1fr`): com um único agente o card fica no
  // seu tamanho natural e alinhado à esquerda, em vez de esticar a tela toda.
  gridTemplateColumns: "repeat(auto-fill, minmax(280px, 340px))",
  justifyContent: "start",
  gap: 24,
});
const centered = css({
  display: "flex",
  justifyContent: "center",
  padding: spacing.xl,
});

export default function AgentsList({ agents, loading }) {
  return (
    <Page
      title="Agentes de IA"
      subtitle="Converse com os seus ou desbloqueie os próximos."
    >
      {loading && !agents.length ? (
        <div className={centered}>
          <Spinner />
        </div>
      ) : (
        <div className={grid}>
          {agents.map((agent) => (
            <AgentCard key={agent.id} agent={agent} />
          ))}
        </div>
      )}
    </Page>
  );
}
